import { locations } from "@/utils/seo/locations";

export const LocationInfo = () => {
  return (
    <div className="hidden">
      <div>
        <h2>Coworking situé au cœur de Paris 9</h2>
        <p>
          Espace Cadet est situé au {locations.address.street},{" "}
          {locations.address.postal} {locations.address.city}.
        </p>
      </div>

      <div>
        <h3>Accès transports</h3>
        <ul>
          <li>
            {locations.metro.cadet.name} (ligne {locations.metro.cadet.line}) à{" "}
            {locations.metro.cadet.distance}, soit{" "}
            {locations.metro.cadet.walkingTime} à pied.
          </li>
          <li>
            {locations.stations.gareNord.name}:{" "}
            {locations.stations.gareNord.distance} (
            {locations.stations.gareNord.walkingTime}).
          </li>
          <li>
            {locations.stations.gareEst.name}:{" "}
            {locations.stations.gareEst.distance} (
            {locations.stations.gareEst.walkingTime}).
          </li>
          <li>
            {locations.stations.gareSaintLazare.name}:{" "}
            {locations.stations.gareSaintLazare.distance} (
            {locations.stations.gareSaintLazare.walkingTime}).
          </li>
        </ul>
      </div>

      <div>
        <h3>Zone de chalandise</h3>
        <p>
          Implantation principale dans le {locations.districts.main}, avec une
          zone d'activité forte sur les arrondissements{" "}
          {locations.districts.nearby.join(", ")}.
        </p>
      </div>
    </div>
  );
};
